import { ChangeEvent, FocusEvent, useState } from 'react';

export interface FieldState {
  value: string;
  error: boolean;
  required: boolean;
  maxLength?: number;
}

interface IUseForm {
  onChange: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  updateInputValidityOnBlurOrFocus: (
    event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  values: FormState;
  setValues: (value: React.SetStateAction<FormState>) => void;
  updateFormValidity: (form: HTMLFormElement | null) => void;
}

export interface FormState {
  [name: string]: FieldState;
}
export const useForm = (initialState: FormState): IUseForm => {
  const [values, setValues] = useState<FormState>(initialState);

  const updateInputValidityOnBlurOrFocus = (
    event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    updateInputValidityStatus(event.currentTarget);
  };

  const updateFormValidity = (form: HTMLFormElement | null): void => {
    if (!form) return;

    const fields = form.querySelectorAll('input');

    for (const field of fields) {
      updateInputValidityStatus(field);
    }
  };

  const updateInputValidityStatus = (
    input: HTMLInputElement | HTMLTextAreaElement,
  ) => {
    //Update input error and value
    const { value, name, required } = input;

    const error = (required && value.trim() === '') || !input.checkValidity();

    setValues((previousVal) => {
      return { ...previousVal, [name]: { ...values[name], value, error } };
    });
  };

  const onChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void => {
    const { value, name } = event.currentTarget;
    setValues((previousVal) => {
      return { ...previousVal, [name]: { ...values[name], value } };
    });
  };

  return {
    onChange,
    updateInputValidityOnBlurOrFocus,
    values,
    setValues,
    updateFormValidity,
  };
};
